export default "__VITE_ASSET__Dn7Gxrhs__"